import { OnInit, Component, EventEmitter, Input, Output, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { Subscription } from "rxjs";
import { first } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { CostCentreService } from "src/app/_services";
import { HowDoIVideoLinks } from "src/app/common/commonvariables";
import { BaseComponent } from "src/app/shared/base/base-component";
import { AlertService } from "src/app/alert-panel/alert.service";
import { SelectCostCentrePopupModel } from "src/app/_models/claimant-on-web/claimant-on-web";
import { ActiveCostCentreResponse, IGetCostCentreResponse, IRequestCostCentre, RequestCostCentre, IRequestCostCentreByOrg, RequestCostCentreByOrg } from "src/app/_models/costCentre/costCentre";
import { ApiRequest, IApiresponse } from "src/app/_models";
import { ActionButtonConfig, ActionPanelConfig, ActionPanelOutput } from "src/app/_models/common/form/form";
import { TwostepapprovalService } from "src/app/_services/twostepapproval/twostepapproval.service";
import { ITwoStepApprovalSaveRequest, TwoStepApprovalSaveRequest } from "src/app/_models/twostepapproval/twostepapproval";
import { environment } from "src/environments/environment";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
import { DatePipe } from "@angular/common";
import { GetField } from "src/app/shared/forms/form-functions/form-functions";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { Claims } from "src/app/_models/common/claims";
import { CostCentreStatusEnum } from "src/app/_models/enum/solo-enum";

@Component({
    selector: "select-cost-centre-panel",
    templateUrl: "./select-cost-centre-panel.component.html",
    standalone: false
})
export class SelectCostCentrePanelComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() fmSpecialObject: any;
    @Input()
    inputData: SelectCostCentrePopupModel;

    @Output() closePanelEvent = new EventEmitter<boolean>();
    @Output() selectItemEvent = new EventEmitter<SelectCostCentrePopupModel>();

    param: any;
    howDoIVideoLinks = HowDoIVideoLinks;
    searchText: string = '';
    hasFormChanges: boolean = false;

    userActionEventSubscription: Subscription;
    claimsSubscription: Subscription;
    claims: Claims;
    costCentreList = <ActiveCostCentreResponse[]>[];
    allCostCentreList = <any[]>[];
    selectedCostCentreId: number = 0;
    isSelectionHide: boolean = false;
    disableSave: boolean= true;
    showCostCentreOnOffPanel: boolean = false;

    // Action panel properties
    actionPanelConfig: ActionPanelConfig;
    actionPanelModel: any;
    hideActionButtons: boolean = false;
    minDate: any;
    today: Date = new Date();

    constructor(private alertService: AlertService,
        private costCentreService: CostCentreService, 
        private cdr:ChangeDetectorRef,
        private translate: TranslateService,
        private datepipe: DatePipe,
        private toastr: ToastrService,
        private claimsService: ClaimsService,
        private twoStepApprovalService: TwostepapprovalService) {
        super();
        this.userActionEventSubscription = this.alertService.getUserActionEvent().subscribe(action => {
            if (action) {
                this.closePanelEvent.emit(true);
            }
        });
        this.claimsSubscription = this.claimsService.currentClaims.subscribe(claims => {
            this.claims = claims;
            // Check if cost-centre-on-off panel should be opened when claims are updated
            this.checkAndOpenCostCentreOnOffPanel();
        });
    }
    ngOnInit(): void {
        this.getCostCentersForOrg(CostCentreStatusEnum.Active);
        this.fnGetActiveCostCentreList();
        this.fnSetCostCentreInputValues();
        this.minDate = this.datepipe.transform(
            this.today.setDate(this.today.getDate() + 1),
            "yyyy-MM-dd"
        );
        
        // Check if cost-centre-on-off panel should be opened
        this.checkAndOpenCostCentreOnOffPanel();
        
    }

    canDeactivate(): boolean {
        return !this.hasFormChanges;
    }

    checkAndOpenCostCentreOnOffPanel(): void {
        // Check if fmSpecialObject has data and IsCostCentreOn is false
        if (this.fmSpecialObject && this.claims && this.claims.isCostCentreOn === false) {
            this.showCostCentreOnOffPanel = true;
        }
    }

    ngOnDestroy() {
        this.userActionEventSubscription.unsubscribe();
        if (this.claimsSubscription) {
            this.claimsSubscription.unsubscribe();
        }
    }

    fnClosePanel() {
        if (this.canDeactivate()) {
            this.closePanelEvent.emit(true);
        }
        else {
            this.alertService.onFormClosed();
        }
    }

    fnCloseCostCentreOnOffPanel(event: boolean): void {
        
        this.showCostCentreOnOffPanel = false;
    }

    fnGetActiveCostCentreList() {
        this.costCentreService
            .GetActiveCostCentre()
            .subscribe((response: IApiresponse<IGetCostCentreResponse>) => {
                if (response.responseInfo != null) {
                    this.costCentreList = response.responseInfo.costCentreValues;
                    this.fnGetSelectedCostCentreOnTop();
                    this.cdr.detectChanges();
                }
            });
    }

    getCostCentersForOrg(status: number) {
        let costCentreRequest = new ApiRequest<IRequestCostCentreByOrg>(
            "SoloGetCostCentresForOrg",
            1.0,
            "111"
        );
        let costCentreRequestInfo = new RequestCostCentreByOrg(
            this.claims.OrgId,
            status,
            0,
            0,
            ''
        );
        costCentreRequest.requestInfo = costCentreRequestInfo;
        this.costCentreService
            .GetCostCentresForOrg(costCentreRequest)
            .subscribe((response: any) => {
                if (response.responseInfo != null) {
                    this.allCostCentreList = response.responseInfo.costCentreList;
                    this.fnGetSelectedCostCentreOnTop();
                    //this.cdr.detectChanges();
                }
            });
    }

    fnSelectCostCentre() {
        
        let selectCostCentreOutputModel = new SelectCostCentrePopupModel();
        if (this.selectedCostCentreId > 0) {
            let costCentreDetails = this.costCentreList.find(item => item.costCentreId == this.selectedCostCentreId);
            if (costCentreDetails) {
                selectCostCentreOutputModel.costCentreId = costCentreDetails.costCentreId;
                selectCostCentreOutputModel.costCentreName = costCentreDetails.derivedName;
            }
        } else {
            selectCostCentreOutputModel.costCentreId = 0;
            selectCostCentreOutputModel.costCentreName = '';
        }
        this.selectItemEvent.emit(selectCostCentreOutputModel);
    }

    fnOnChangeCostCentre(costCentreId: number) {
        if (costCentreId == this.selectedCostCentreId) {
            this.selectedCostCentreId = 0;
        } else {
            this.selectedCostCentreId = costCentreId;
        }

        //enabled / disabled save button
        if(this.isSelectionHide){
            if(!this.selectedCostCentreId){
                this.disableSave = true;
            }
            else{
                this.disableSave = false;
            }
        }       
        else{
            this.disableSave = false;
        }
    }

    fnSetCostCentreInputValues() {
        if (this.inputData) {
            this.selectedCostCentreId = this.inputData.costCentreId;
            this.isSelectionHide = this.inputData.isSelectionHide;
        }
    }
    fnGetSelectedCostCentreOnTop() {
        let costCentreId = this.inputData && this.inputData.costCentreId ? this.inputData.costCentreId : 0;

        if (costCentreId && this.costCentreList && this.costCentreList.length > 0) {
            const sortedArr = this.costCentreList.reduce((acc, element) => {
                if (element.costCentreId == costCentreId) {
                    return [element, ...acc];
                }
                return [...acc, element];
            }, []);
            this.costCentreList = sortedArr;
        }
    }

    fnAddCostCentre() {
        this.initSaveCostCentrePanel(null);
    }

    fnOpenMaintainCostCentres() {
        // Check if a cost centre is selected
        if (this.selectedCostCentreId && this.selectedCostCentreId > 0) {
            // Find the selected cost centre details from allCostCentreList for complete data
            let costCentreDetails = this.allCostCentreList.find(cc => cc.costCentreId === this.selectedCostCentreId);
            
            if (!costCentreDetails) {
                // If not found in allCostCentreList, find from costCentreList
                let costCentre = this.costCentreList.find(cc => cc.costCentreId === this.selectedCostCentreId);
                if (costCentre) {
                    costCentreDetails = {
                        costCentreId: costCentre.costCentreId,
                        costCentreName: costCentre.derivedName,
                        costCentreCode1: costCentre.costCentreCode1 || '',
                        costCentreCode2: costCentre.costCentreCode2 || '',
                        status: 1, // Assuming active status
                        organisationId: this.claims.OrgId
                    };
                }
            }
            
            if (costCentreDetails) {
                // Open edit modal for the selected cost centre
                this.initSaveCostCentrePanel(costCentreDetails);
            } else {
                this.toastr.error('Selected cost centre details not found', 'Error');
            }
        } else {
            // No cost centre selected, show message
            this.toastr.info('Please select a cost centre first to maintain it', 'Information');
        }
    }

    initSaveCostCentrePanel(costCentre) {
        const buttonConfig: ActionButtonConfig[] = [];

        this.actionPanelModel = {};
        if (costCentre) {
            this.actionPanelModel = costCentre;
            this.actionPanelModel.ccStatus = costCentre.status == 1 ? true : false;
            if (costCentre.replacementDate) {
                this.actionPanelModel.replacementDate = this.datepipe.transform(
                    costCentre.replacementDate,
                    "yyyy-MM-dd"
                );
            }
        }
        
        buttonConfig.push({
            buttonClass: 'btn eod-btn-primary mr-2',
            buttonTooltip: 'label_save',
            key: 'save',
            disableWhenNotDirty: true
        });

        this.actionPanelConfig = {
            panelKey: costCentre ? 'EditPanel' : 'AddPanel',
            subtitle: '',
            headerTitle: costCentre ? 'cost_center_edit_heading' : 'cost_center_add',
            isOverlay: true,
            isMultipleSelected: false,
            selectedItemCount: 0,
            formData: this.initializeCCForm(costCentre),
            buttonConfig: buttonConfig,
            disableButtonsOnInvalid: false
        }
    }

    initializeCCForm(costCentre) {
        let fields: FormlyFieldConfig[] = [];

        if (costCentre) {
            fields.push({
                fieldGroup: [
                    {
                        key: 'ccStatus',
                        type: 'formly-toggle-input',
                        templateOptions: {
                            options: [{
                                mainClass: ""
                            }],
                            labelActive: this.translate.instant("label_activate"),
                            labelDeactive: this.translate.instant("label_deactivate"),
                            change: (field, $event) => {
                                this.hasFormChanges = true;
                            }
                        }
                    }
                ]
            });
        }

        fields.push({
            fieldGroupClassName: 'block row margin-top-10',
            fieldGroup: [
                {
                    key: 'costCentreName',
                    type: 'text-input',
                    className: 'col-md-12 no-padding-right-left',
                    templateOptions: {
                        label: this.translate.instant('cost_center_name_label'),
                        placeholder: '',
                        required: true,
                        maxLength: 100,
                        maxLengthCount: true,
                        change: (field, $event) => {
                            this.hasFormChanges = true;
                            GetField('costCentreName', this.actionPanelConfig.formData).templateOptions.customErrors = [];
                        }
                    }
                },
                {
                    key: 'costCentreCode1',
                    type: 'text-input',
                    className: 'col-md-6 padding-left-0',
                    templateOptions: {
                        label: this.translate.instant('cost_center_code1'),
                        placeholder: '',
                        required: true,
                        maxLength: 50,
                        maxLengthCount: true,
                        change: (field, $event) => {
                            this.hasFormChanges = true;
                            GetField('costCentreCode1', this.actionPanelConfig.formData).templateOptions.customErrors = [];
                        }
                    }
                },
                {
                    key: 'costCentreCode2',
                    type: 'text-input',
                    className: 'col-md-6 padding-right-0',
                    templateOptions: {
                        label: this.translate.instant('cost_center_code2'),
                        placeholder: '',
                        required: false,
                        maxLength: 50,
                        maxLengthCount: true,
                        change: (field, $event) => {
                            this.hasFormChanges = true;
                        }
                    }
                }
            ]
        });

        return fields;
    }

    onActionPanelSubmit(result: ActionPanelOutput) {
        switch (result.buttonKey) {
            case 'close':
                this.onCloseActionPanel();
                break;
            case 'save':
                const model = result.panelKey == "EditPanel" ? this.actionPanelModel : result.formModel;
                this.saveCostCentre(model);
                break;
        }
    }

    onCloseActionPanel() {
        this.actionPanelModel = null;
        this.actionPanelConfig = null;
        this.hasFormChanges = false;
    }

    saveCostCentre(model) {
        if (this.validateCostCentre(model)) {
            const isEdit = model.costCentreId && model.costCentreId > 0;
            
            let costCentreSaveRequest = new ApiRequest<IRequestCostCentre>(
                isEdit ? "SoloUpdateCostCentre" : "SoloCreateCostCentre",
                1.0,
                "111"
            );
            
            costCentreSaveRequest.requestInfo = new RequestCostCentre(
                isEdit ? model.costCentreId : 0, // costCentreId
                this.claims.OrgId, // organisationId
                model.costCentreName, // costCentreName
                model.costCentreCode1, // costCentreCode1
                model.costCentreCode2 || null, // costCentreCode2
                null, // replacementDate
                null, // newCostCentreName
                null, // newCostCentreCode1
                null, // newCostCentreCode2
                model.ccStatus !== undefined ? (model.ccStatus ? 1 : 2) : 1, // status
                this.claims.UserId, // createdBy/modifiedBy
                model.createdDate ? model.createdDate : new Date(), // createdDate
                model.costCentreId ? this.claims.UserId : null, // modifiedBy
                model.costCentreId ? new Date() : null, // modifiedDate
                this.claims.FinanceManager // createdByName
            );
            
            const serviceMethod = isEdit ? 
                this.costCentreService.UpdateCostCentre(costCentreSaveRequest) : 
                this.costCentreService.CreateCostCentre(costCentreSaveRequest);
            
            serviceMethod.pipe(first()).subscribe(
                (apiResponse: IApiresponse<any>) => {
                    if (apiResponse) {
                        if (apiResponse.statusCode === 200) {
                            this.toastr.success(this.translate.instant("success"));
                            this.onCloseActionPanel();
                            this.getCostCentersForOrg(CostCentreStatusEnum.Active);
                            this.fnGetActiveCostCentreList();
                        } else {
                            if (apiResponse.message != null && apiResponse.message != "") {
                                this.toastr.error(apiResponse.message, this.translate.instant("app.common.Error"));
                            } else {
                                this.toastr.error(this.translate.instant("app.common.SomethingWentWrong"), this.translate.instant("app.common.Error"));
                            }
                        }
                    }
                },
                error => {
                    this.toastr.error(this.translate.instant("app.common.SomethingWentWrong"), this.translate.instant("app.common.Error"));
                }
            );
        }
    }

    validateCostCentre(model): boolean {
        let checkResult = true;
        
        if (!model.costCentreName || model.costCentreName.trim() === '') {
            this.toastr.error(this.translate.instant("app.costcentre.costcentre.msg.CostCentreNameRequired"), this.translate.instant("app.common.Error"));
            return false;
        }
        
        if (!model.costCentreCode1 || model.costCentreCode1.trim() === '') {
            this.toastr.error(this.translate.instant("app.costcentre.costcentre.msg.CostCentreCodeRequired"), this.translate.instant("app.common.Error"));
            return false;
        }
        
        // Check for duplicate name (exclude current item if editing)
        if (this.allCostCentreList && this.allCostCentreList.length > 0) {
            const duplicateName = this.allCostCentreList.find(cc => 
                cc.costCentreName && 
                cc.costCentreName.toLowerCase() === model.costCentreName.toLowerCase().trim() &&
                cc.costCentreId !== model.costCentreId // Exclude current item if editing
            );
            if (duplicateName) {
                this.toastr.error(this.translate.instant('cost_center_name_already_exists'), this.translate.instant('label_error'));
                return false;
            }
            
            // Check for duplicate code (exclude current item if editing)
            const duplicateCode = this.allCostCentreList.find(cc => 
                cc.costCentreCode1 && 
                cc.costCentreCode1.toLowerCase() === model.costCentreCode1.toLowerCase().trim() &&
                cc.costCentreId !== model.costCentreId // Exclude current item if editing
            );
            if (duplicateCode) {
                this.toastr.error(this.translate.instant('cost_center_code_already_exists'), this.translate.instant('label_error'));
                return false;
            }
        }
        
        return checkResult;
    }
}
